export class EmployeeFilter {
    
    public EmployeeID?: number;
    SalesOfficeIDs?: number[];
    FeatureIDs?: number[];
    public Username?: string;
    public Password?: string;
    IncludeInactive?: boolean;
    EmployeeNameOrPersonnelNumberLike?: string;
    Take?: number;
}

export default EmployeeFilter;